import React, { useState } from 'react';

const LayoutContext = React.createContext(null);

const LayoutProvider = ({ children }) => {
	const [isHeaderVisible, setIsHeaderVisible] = useState(true);
	const [isFooterVisible, setIsFooterVisible] = useState(true);

	return (
		<LayoutContext.Provider value={{ isHeaderVisible, setIsHeaderVisible, isFooterVisible, setIsFooterVisible }}>
			{children}
		</LayoutContext.Provider>
	);
};

export {
	LayoutProvider,
	LayoutContext
}

